export default {
  SAC_1: {
    title: 'Transições por Status de Atendimento',
    description: 'Tabela com o total de transições feitas entre os status de atendimento no período de tempo selecionado.',
  },
  SAC_2: {
    title: 'Timeline de Publicações Proprietárias',
    description: 'Lista ordenada por data (mais recente) das publicações feitas pelos perfis cadastrados (inclui posts e interações feitas pelas páginas).',
  },
  SAC_3: {
    title: 'Engajamento Recebido',
    description: 'Somatória de todas as ações de engajamento recebidas a partir de publicações proprietárias filtradas na pesquisa.',
  },
  SAC_4: {
    title: 'Curtidas Recebidas',
    description: 'Somatória de todas as curtidas recebidas a partir de publicações proprietárias e filtradas na pesquisa.',
  },
  SAC_5: {
    title: 'Comentários Recebidos',
    description: 'Somatória de todos os comentários recebidos a partir de publicações proprietárias realizadas no período selecionado e filtradas na pesquisa.',
    info: {
      title: 'Por que este número é diferente das Métricas Proprietárias?',
      intro: 'Este componente soma os comentários das publicações da sua marca — Publicações proprietárias, Story e Reels — em todas as redes conectadas à pesquisa. As Métricas Proprietárias mostram uma rede por vez, como o Instagram.',
      type: 'Dois filtros também alteram o resultado: Interações em "Indiferente" inclui interações de terceiros, como menções.',
      status: 'Status se aplica a itens de atendimento. Ao usá-lo, mesmo com "Selecione todos", as publicações da sua marca saem da soma.',
      compare: 'Para comparar os dois números, use o mesmo período, a mesma página e a mesma rede social. Deixe Status sem seleção e, em Interações, selecione apenas Publicações proprietárias, Story e Reels.',
    },
  },
  SAC_6: {
    title: 'Posts e Interações',
    description: 'Contagem de publicações das páginas conectadas e filtradas na pesquisa. Mostra publicações proprietárias por padrão, mas pode ser ajustado para mostrar todos os tipos de interação.',
  },
  SAC_7: {
    title: 'Impressões',
    description: 'Somatória do total de impressões orgânicas e pagas a partir de publicações proprietárias e filtradas na pesquisa.',
  },
  SAC_8: {
    title: 'Alcance',
    description: 'Somatória do total de alcance conquistado a partir de publicações proprietárias e filtradas na pesquisa.',
  },
  SAC_9: {
    title: 'Views',
    description: 'Somatória das visualizações de vídeos nos canais proprietários existentes na pesquisa e filtrados.',
  },
  SAC_10: {
    title: 'Impressões no Tempo',
    description: 'Somatória do total de impressões a partir de publicações proprietárias filtradas na pesquisa, disposta no período selecionado. No Instagram, apenas Stories retornam esse dado, por limitação da Meta.',
  },
  SAC_11: {
    title: 'Alcance no Tempo',
    description: 'Somatória do total de alcance conquistado a partir de publicações proprietárias e filtradas na pesquisa disposta no período de tempo selecionado.',
  },
  SAC_12: {
    title: 'Engajamento Recebido no Tempo',
    description: 'Somatória de todas as ações de engajamento recebidas a partir de publicações proprietárias filtradas na pesquisa disposta no período de tempo selecionado.',
  },
  SAC_13: {
    title: 'Publicações com mais engajamento',
    description: 'Cards em forma de lista contendo conteúdo proprietário ordenado pelo total de engajamento conquistado.',
  },
  SAC_14: {
    title: 'Sentimento das Interações no tempo',
    description: 'Distribuição das interações recebidas por sua polaridade ao longo de um período de tempo.',
  },
  SAC_15: {
    title: 'Termômetro de Sentimento das interações',
    description: 'Representa o resultado da equação: (publicações positivas / publicações coletadas * 100) - (publicações negativas / publicações coletadas * 100) aplicada apenas para interações recebidas.',
  },
  SAC_16: {
    title: 'Engajamento por canal no tempo',
    description: 'Distribuição das interações recebidas divididas por canal proprietário ao longo de um período de tempo.',
  },
  SAC_17: {
    title: 'Usuários interagindo',
    description: 'Contagem de usuários únicos que interagiram com os canais proprietários.',
  },
  SAC_18: {
    title: 'Sentimento por Canal Proprietário',
    description: 'Distribuição de publicações (posts + interações) pelos canais proprietários e sua divisão por polaridade.',
  },
  SAC_19: {
    title: 'Sentimento por Tag Proprietária',
    description: 'Distribuição de publicações (posts + interações) pelas tags atribuídas e sua divisão por polaridade.',
  },
  SAC_20: {
    title: 'Sentimento das Interações por Gênero',
    description: 'Distribuição de interações por Gênero e sua divisão por polaridade',
  },
  SAC_21: {
    title: 'Sentimento por Temas',
    description: 'Distribuição de publicações (posts + interações) pelos temas da pesquisa e sua divisão por polaridade.',
  },
  SAC_22: {
    title: 'Distribuição de Sentimento das Interações',
    description: 'Divisão das interações por polaridade positiva, negativa ou neutra.',
  },
  SAC_23: {
    title: 'Publicações Proprietárias Mais Comentadas',
    description: 'Cards em forma de carrossel contendo conteúdo proprietário ordenado pelo total de comentários recebidos.',
  },
  SAC_24: {
    title: 'Interações por canal',
    description: 'Distribuição do volume das interações recebidas divididas por canal proprietário.',
  },
  SAC_25: {
    title: 'Interações por usuário',
    description: 'Razão entre o número de interações dividido pela quantidade de usuários interagindo.',
  },
  SAC_26: {
    title: 'Sentimento das interações no tempo percentual',
    description: 'Distribuição das interações recebidas pela proporção percentual de positivas, negativas e neutras ao longo de um período de tempo.',
  },
  SAC_27: {
    title: 'Atendimentos por Operadores',
    description: 'Distribuição percentual do volume de atendimentos realizados por cada operador.',
  },
  SAC_28: {
    title: 'Quantidade de usuários com mais de 1 Interação',
    description: 'Volume total de usuários que interagiram mais de uma vez com os conteúdos proprietários.',
  },
  SAC_29: {
    title: 'Distribuição por Tema (Proprietários)',
    description: 'Volume de publicações ou interações nos perfis proprietários distribuídos por temas cadastrados na pesquisa.',
  },
  SAC_30: {
    title: 'Distribuição por Tag (Proprietários)',
    description: 'Volume de publicações ou interações nos perfis proprietários distribuídos por tags atribuídas.',
  },
  SAC_31: {
    title: 'Total de fãs',
    description: 'Total de Fãs das páginas selecionadas na data final do período pesquisado.',
  },
  SAC_32: {
    title: 'Novos fãs',
    description: 'Total de fãs conquistados pelas páginas selecionadas no período pesquisado.',
  },
  SAC_33: {
    title: 'Evolução da Base de Fãs',
    description: 'Variação diária de fãs das páginas pesquisadas no período, relativa ao dia anterior.',
  },
  SAC_34: {
    title: 'Matriz de engajamento por publicações',
    description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações proprietárias do período. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
  },
  SAC_35: {
    title: 'Matriz de engajamento por tags',
    description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações do período, por tag. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
  },
  SAC_36: {
    title: 'Volume de atendimentos por operador',
    description: 'Total de eventos contabilizados entre o "Status Antigos" e o "Status Novos", filtrados na pesquisa por operador. Não contabiliza conversas pendentes novas em que ainda não haja mudança de status.',
  },
  SAC_37: {
    title: 'Volume de atendimentos por página',
    description: 'Total de eventos contabilizados entre o "Status Antigos" e o "Status Novos", filtrados na pesquisa por página. Não contabiliza conversas pendentes novas em que ainda não haja mudança de status.',
  },
  SAC_38: {
    title: 'Volume de atendimentos no tempo',
    description: 'Total de eventos contabilizados entre o "Status Antigos" e o "Status Novos", filtrados na pesquisa no tempo. Não contabiliza conversas pendentes novas em que ainda não haja mudança de status.',
  },
  SAC_39: {
    title: 'Total de atendimentos',
    description: 'Total de eventos contabilizados entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa (OBS.: Não contabiliza novas conversas pendentes onde ainda não ocorreu mudança de status).',
  },
  SAC_40: {
    title: 'Tempo médio de atendimento por operador',
    description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa, por operador.',
  },
  SAC_41: {
    title: 'Tempo médio de atendimento por página',
    description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa, por página.',
  },
  SAC_42: {
    title: 'Tempo Médio de atendimento no tempo',
    description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa, no tempo.',
  },
  SAC_43: {
    title: 'Tempo médio de atendimento total',
    description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa.',
  },
  SAC_44: {
    title: 'Atendimentos por operadores no tempo',
  },
  SAC_45: {
    title: 'Relatório de operadores',
    description: 'Relatório de logs dos operadores',
  },
  SAC_46: {
    title: 'Relatório de produtividade',
    description: 'Relatório de produtividade',
  },
  SAC_47: {
    title: 'Tabela de Backlog',
    description: 'Tabela dos casos abertos mais antigos.',
  },
  SAC_48: {
    title: 'SLA',
    description: 'Conversas respondidas dentro do SLA',
  },
  SAC_49: {
    title: 'Produtividade',
    description: 'Métrica de avaliação de desempenho dos atendimentos realizados pelos operadores em relação aos casos recebidos. Representa o resultado da equação (total de atendimentos realizados / total de casos recebidos * 100).',
  },
  SAC_50: {
    title: 'Produtividade por dia',
    description: 'Distribuição do índice de produtividade por dia ao longo do tempo. Mede a avaliação de desempenho dos atendimentos realizados pelos operadores em relação aos casos recebidos.',
  },
  SAC_51: {
    title: 'Volume de atendimentos recebidos x atendidos',
    description: 'Quantidade de atendimentos recebidos em comparação aos atendidos ao longo do tempo.',
  },
  SAC_52: {
    title: 'Status dos Operadores',
    description: 'Tabela com os status de atendimento de todos os operadores',
  },
  SAC_53: {
    title: 'Avaliações Consolidadas',
    description: 'Exibe pesquisa de satisfação do cliente por sentimento',
  },
  SAC_54: {
    title: 'Avaliações no Tempo',
    description: 'Exibe pesquisa de satisfação do cliente',
  },
  SAC_55: {
    title: 'Avaliações do Atendimento',
    description: 'Tabela com as avaliações de atendimento realizados via smartcare.',
  },
  SAC_56: {
    title: 'Tabela de Lovers',
    description: 'Tabela de usuários mais engajados',
  },
  SAC_57: {
    title: 'Interesses dos lovers',
    description: 'Divisão de interesses encontrados nas publicações dos usuários',
  },
  SAC_58: {
    title: 'Tempo médio de atendimento',
    description: 'Tempo em cada status da conversa.',
  },
  SAC_59: {
    title: 'Matriz de performance dos usuários',
    description: 'Matriz de performance dos usuários, detalhando a hora de atuação de cada operador',
  },
  SAC_60: {
    title: 'Quantidade de atendimento por canal',
    description: 'Tabela com a quantidade de atendimento dividida por canais',
  },
  SAC_61: {
    title: 'Publicações por tag',
    description: 'Distribuição de publicações pelas tags atribuídas para dados proprietários',
  },
  SAC_62: {
    title: 'Publicações por Tag no Tempo',
    description: 'Distribuição de publicações pelas Tags atribuídas na pesquisa ao longo do tempo.',
  },
  SAC_63: {
    title: 'Interações no tempo',
    description: 'Distribuição linear das interações coletadas ao longo de um período de tempo.',
  },
  SAC_64: {
    title: 'Publicações por Tag',
    description: 'Distribuição de publicações pelas Tags atribuídas',
  },
  SAC_65: {
    title: 'Projeção amostragem de publicações',
    description: 'Projeção do volume de publicações coletadas no período pesquisado, considerando a amostragem de publicações',
  },
  SAC_66: {
    title: 'Avaliações no Google Meu Negócio',
    description: 'Quantidade de avaliações por número de estrelas no canal Google Meu Negócio.',
  },
  SAC_67: {
    title: 'Interações roteadas ao longo do tempo',
    description: 'Distribuição das interações por configuração de roteamento ao longo do tempo.',
  },
};
